import React, { useEffect, useState } from "react";
import API_URL from "../../functions/config";

const EmpRecord = () => {
    const [reportType, setReportType] = useState("today");

    const [month, setMonth] = useState("");

    const [fromDate, setFromDate] = useState("");

    const [toDate, setToDate] = useState("");

    const [report, setReport] = useState(null);

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState("");

    const token = localStorage.getItem("emptoken");

        const totalWorkingSeconds = (report?.attendance || []).reduce(
    (total, record) => total + (Number(record.workingMinutes) || 0),
    0
);


    const user = JSON.parse(localStorage.getItem("empuser"));
    const employeeId = user?._id;
    const companyId = user?.compid;

    // =====================================
    // FETCH REPORT
    // =====================================

    const fetchReport = async () => {

        if (!employeeId) {
            setError("Employee ID not found");
            return;
        }

        try {

            setLoading(true);
            setError("");

            let url =
                `${API_URL}/emprecord?empid=${employeeId}&companyId=${companyId}&type=${reportType}`;

            if (reportType === "monthly") {

                if (!month) {
                    setError("Please select month");
                    return;
                }

                url += `&month=${month}`;
            }

            if (reportType === "custom") {

                if (!fromDate || !toDate) {
                    setError("Please select From Date and To Date");
                    return;
                }

                if (fromDate > toDate) {
                    setError("From Date cannot be greater than To Date");
                    return;
                }

                url += `&fromDate=${fromDate}&toDate=${toDate}`;
            }

            // console.log("API URL:", url);
            // console.log("TOKEN:", token);

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            const data = await response.json();

            //console.log("API RESPONSE:", data);

            if (!response.ok) {
                throw new Error(
                    data.result || "Failed to fetch report"
                );
            }




            // IMPORTANT
            setReport(data.result);

        } catch (err) {

            console.error("Report Error:", err);

            setError(err.message);

        } finally {

            setLoading(false);

        }
    };


    // =====================================
    // LOAD TODAY REPORT
    // =====================================

    useEffect(() => {

        if (employeeId) {
            fetchReport();
        }

    }, [employeeId]);


    // =====================================
    // CHANGE REPORT TYPE
    // =====================================

    const handleReportTypeChange = (e) => {

        const type = e.target.value;

        setReportType(type);

        setError("");

        // Automatically fetch Today
        if (type === "today") {

            setTimeout(() => {
                fetchReport();
            }, 0);

        }

    };


    // =====================================
    // FORMAT DATE TIME
    // =====================================

    const formatDateTime = (date) => {

        if (!date) {
            return "--";
        }

        const d = new Date(date);

        if (isNaN(d)) {
            return "--";
        }

        return d.toLocaleString("en-IN", {

            day: "2-digit",
            month: "short",
            year: "numeric",

            hour: "2-digit",
            minute: "2-digit",

            hour12: true

        });
    };


    // =====================================
    // FORMAT MINUTES
    // =====================================

    const formatWorkingTime = (totalSeconds) => {

        totalSeconds = Number(totalSeconds) || 0;

        const hours = Math.floor(totalSeconds / 3600);

        const minutes = Math.floor(
            (totalSeconds % 3600) / 60
        );

        const seconds = totalSeconds % 60;

        return (
            `${String(hours).padStart(2, "0")}:` +
            `${String(minutes).padStart(2, "0")}:` +
            `${String(seconds).padStart(2, "0")}`
        );
    };




    const formatDate = (date) => {
        if (!date) return "--";

        return new Date(date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };




    return (
        <div className="container">

            <div className="container-fluid py-4">

                {/* ================================= */}
                {/* PAGE HEADER */}
                {/* ================================= */}

                <div className="d-flex justify-content-between align-items-center mb-4">

                    <div>

                        <h3 className="fw-bold mb-1">
                            Employee Attendance Report
                        </h3>

                        <p className="text-muted mb-0">
                            View employee attendance and working hours
                        </p>

                    </div>

                    <button
                        className="btn btn-outline-primary"
                        onClick={fetchReport}
                        disabled={loading}
                    >

                        {loading ? "Loading..." : "Refresh"}

                    </button>

                </div>


                {/* ================================= */}
                {/* EMPLOYEE INFORMATION */}
                {/* ================================= */}

                {report?.employee && (

                    <div className="card border-0 shadow-sm mb-4">

                        <div className="card-body">

                            <div className="row align-items-center">

                                <div className="col-md-8">

                                    <h4 className="fw-bold mb-1">

                                        {report.employee.name}

                                    </h4>

                                    <div className="text-muted">

                                        {report.employee.emailid}

                                    </div>

                                </div>


                                <div className="col-md-4 text-md-end mt-3 mt-md-0">

                                    <span className="badge text-bg-primary px-3 py-2">

                                        {report.reportType}

                                    </span>

                                </div>

                            </div>

                        </div>

                    </div>

                )}


                {/* ================================= */}
                {/* FILTER */}
                {/* ================================= */}

                <div className="card border-0 shadow-sm mb-4">

                    <div className="card-body">

                        <div className="row g-3 align-items-end">

                            {/* REPORT TYPE */}

                            <div className="col-md-4">

                                <label className="form-label fw-semibold">

                                    Report Type

                                </label>

                                <select
                                    className="form-select"
                                    value={reportType}
                                    onChange={handleReportTypeChange}
                                >

                                    <option value="today">
                                        Today
                                    </option>

                                    <option value="monthly">
                                        Monthly
                                    </option>

                                    <option value="custom">
                                        Custom Date
                                    </option>

                                </select>

                            </div>


                            {/* MONTH */}

                            {reportType === "monthly" && (

                                <div className="col-md-4">

                                    <label className="form-label fw-semibold">

                                        Select Month

                                    </label>

                                    <input
                                        type="month"
                                        className="form-control"
                                        value={month}
                                        onChange={(e) =>
                                            setMonth(e.target.value)
                                        }
                                    />

                                </div>

                            )}


                            {/* FROM DATE */}

                            {reportType === "custom" && (

                                <div className="col-md-3">

                                    <label className="form-label fw-semibold">

                                        From Date

                                    </label>

                                    <input
                                        type="date"
                                        className="form-control"
                                        value={fromDate}
                                        onChange={(e) =>
                                            setFromDate(e.target.value)
                                        }
                                    />

                                </div>

                            )}


                            {/* TO DATE */}

                            {reportType === "custom" && (

                                <div className="col-md-3">

                                    <label className="form-label fw-semibold">

                                        To Date

                                    </label>

                                    <input
                                        type="date"
                                        className="form-control"
                                        value={toDate}
                                        onChange={(e) =>
                                            setToDate(e.target.value)
                                        }
                                    />

                                </div>

                            )}


                            {/* GENERATE BUTTON */}

                            <div className="col-md-3">

                                <button
                                    className="btn btn-primary w-100"
                                    onClick={fetchReport}
                                    disabled={loading}
                                >

                                    {loading
                                        ? "Generating..."
                                        : "Generate Report"
                                    }

                                </button>

                            </div>

                        </div>

                    </div>

                </div>


                {/* ================================= */}
                {/* ERROR */}
                {/* ================================= */}

                {error && (

                    <div
                        className="alert alert-danger"
                        role="alert"
                    >

                        {error}

                    </div>

                )}


                {/* ================================= */}
                {/* LOADING */}
                {/* ================================= */}

                {loading && (

                    <div className="text-center py-5">

                        <div
                            className="spinner-border text-primary"
                            role="status"
                        >
                        </div>

                        <div className="mt-2 text-muted">

                            Loading attendance report...

                        </div>

                    </div>

                )}


                {/* ================================= */}
                {/* REPORT */}
                {/* ================================= */}

                {!loading && report && (

                    <>

                        {/* SUMMARY CARDS */}

                        <div className="row g-3 mb-4">

                            <div className="col-md-4">

                                <div className="card border-0 shadow-sm h-100">

                                    <div className="card-body">

                                        <div className="text-muted small mb-2">

                                            Total Working Hours

                                        </div>

                                        <h3 className="fw-bold mb-0">

                                           {formatWorkingTime(totalWorkingSeconds)}

                                        </h3>

                                    </div>

                                </div>

                            </div>


                            <div className="col-md-4">

                                <div className="card border-0 shadow-sm h-100">

                                    <div className="card-body">

                                        <div className="text-muted small mb-2">

                                            Attendance Days

                                        </div>

                                        <h3 className="fw-bold mb-0">

                                            {report.totalAttendanceDays || 0}

                                        </h3>

                                    </div>

                                </div>

                            </div>


                            <div className="col-md-4">

                                <div className="card border-0 shadow-sm h-100">

                                    <div className="card-body">

                                        <div className="text-muted small mb-2">

                                            Report Period

                                        </div>

                                        <h6 className="fw-bold mb-0">

                                            {formatDate(report.fromDate)}

                                            {" → "}

                                            {formatDate(report.toDate)}

                                        </h6>

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* ================================= */}
                        {/* ATTENDANCE TABLE */}
                        {/* ================================= */}

                        <div className="card border-0 shadow-sm">

                            <div className="card-header bg-white py-3">

                                <div className="d-flex justify-content-between align-items-center">

                                    <h5 className="fw-bold mb-0">

                                        Attendance Details

                                    </h5>

                                    <span className="badge text-bg-light">

                                        {report.attendance?.length || 0}
                                        {" "}
                                        Records

                                    </span>

                                </div>

                            </div>


                            <div className="table-responsive">

                                <table className="table table-hover align-middle mb-0">

                                    <thead className="table-light">

                                        <tr>

                                            <th>#</th>

                                            <th>Date</th>

                                            <th>Last CheckIn</th>

                                            <th>Last CheckOut</th>

                                            <th>Total Working Hours</th>

                                            <th>Status</th>

                                        </tr>

                                    </thead>


                                    <tbody>

                                        {report.attendance?.length > 0 ? (

                                            report.attendance.map(
                                                (record, index) => (

                                                    <tr key={record._id || index}>

                                                        <td>
                                                            {index + 1}
                                                        </td>

                                                        <td>

                                                            <span className="fw-semibold">

                                                                {record.date}

                                                            </span>

                                                        </td>

                                                        <td>

                                                            {formatDateTime(
                                                                record.checkIn
                                                            )}

                                                        </td>

                                                        <td>

                                                            {formatDateTime(
                                                                record.checkOut
                                                            )}

                                                        </td>

                                                        <td>

                                                            <span className="fw-semibold">

                                                                {formatWorkingTime(
                                                                    record.workingMinutes
                                                                )}

                                                            </span>

                                                        </td>

                                                        <td>

                                                            <span
                                                                className={
                                                                    record.status ===
                                                                        "Present"
                                                                        ? "badge text-bg-success"
                                                                        : "badge text-bg-danger"
                                                                }
                                                            >

                                                                {record.status ||
                                                                    "Present"}

                                                            </span>

                                                        </td>

                                                    </tr>

                                                )
                                            )

                                        ) : (

                                            <tr>

                                                <td
                                                    colSpan="6"
                                                    className="text-center py-5 text-muted"
                                                >

                                                    No attendance records found

                                                </td>

                                            </tr>

                                        )}

                                    </tbody>

                                </table>

                            </div>

                        </div>

                    </>

                )}

            </div>


        </div>

    )
}


export default EmpRecord;